import { z } from 'zod';

import type { EntityContractInput } from '@/lib/api/domains/entity-contracts';

/*
 * Send-contract form schema. Mirrors the form + transform pattern of the entity
 * slices: a Zod schema for the fields the user edits, plus a
 * `toEntityContractInput` transform to the API input shape. The prototype
 * send-contract modal collects the partner, the relationship/contract type, an
 * effective date, and a `.docx` document upload; the document is a BFF concern
 * (see review.md), so the FE-owned contract input carries the three text fields.
 * Optional `effectiveDate` normalizes blank → undefined so the BFF never
 * receives an empty string.
 */
export const entityContractFormSchema = z.object({
  partnerName: z.string().min(1, 'Partner name is required.'),
  relationshipType: z.string().min(1, 'Relationship type is required.'),
  effectiveDate: z.string().optional(),
});

export type EntityContractFormValues = z.infer<typeof entityContractFormSchema>;

/** Convert form values to the API input shape (drops blank optionals). */
export function toEntityContractInput(
  values: EntityContractFormValues,
): EntityContractInput {
  const effectiveDate = values.effectiveDate?.trim();
  return {
    partnerName: values.partnerName,
    relationshipType: values.relationshipType,
    ...(effectiveDate ? { effectiveDate } : {}),
  };
}
